(function () {
    'use strict';

    angular
        .module('app')
        .controller('OrdersController', OrdersController);

    OrdersController.$inject = ['$scope', '$rootScope', '$timeout', '$filter',
        'blockUI', '$uibModal',
        'ExportService',
        'OrderService',
        'SelectService',
        'CustomerService',
        'CustomPreferencesService',
        'BusinessService',
        'LoyaltyService',
        'SettingsService'];

    function OrdersController(
        $scope, $rootScope, $timeout, $filter,
        blockUI, $uibModal,
        ExportService,
        OrderService,
        SelectService,
        CustomerService,
        CustomPreferencesService,
        BusinessService,
        LoyaltyService,
        SettingsService) {

        $scope.getFiltersList = SelectService.getLList;
        var customPreferencesKey = 'ORDERS_TABLE_COLS';

        $scope.getPages = getTotalPaginatedPages;
        $scope.getOrders = getOrders;
        $scope.getOrderStatusDescription = getOrderStatusDescription;
        $scope.getOrderPaymentTypeDescription = getOrderPaymentTypeDescription;
        $scope.getOrderPaidDescription = getOrderPaidDescription;
        $scope.isSupportUserExternalId = false;

        $scope.model = {
            by_stock: false
        };

        $scope.params = {
            orders_preset: {
                page: 1,
                count: 20,
                date_from: moment().subtract(1, 'month').utc().toDate(),
                date_to: moment().endOf('day').utc().toDate(),
                time_from: moment().startOf('day').utc().toDate(),
                time_to: moment().endOf('day').utc().toDate(),
                status: 'all',
                paid: 'all',
                sort_direction: "DESC",
                sort_field: "created"
            }
        };

        $scope.data = {
            showTableDisplaySettings: false,
            isFilePreparing: false,
            ordersList: null,
            summary: {},
            pagerLengths: [10, 20, 50, 100, 200]
        };

        $scope.data.order_status_list = [
            {value: 'all', title: 'TEXT_ALL_ORDERS'},
            {value: 'created', title: 'TEXT_ORDER_STATUS_CREATED'},
            {value: 'inprocess', title: 'TEXT_ORDER_STATUS_INPROCESS'},
            {value: 'delivered', title: 'TEXT_ORDER_STATUS_DELIVERED'},
            {value: 'canceled', title: 'TEXT_ORDER_STATUS_CANCELED'}
        ];

        $scope.data.order_paid_status_list = [
            {value: 'all', title: 'TEXT_ALL_ORDERS'},
            {value: 'yes', title: 'TEXT_PAID'},
            {value: 'no', title: 'No'}
        ];

        $scope.data.table_cols_preset = [
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'user_phone', text: 'Customer number', visible: true},
                    {value: 'user_email', text: 'Customer email', visible: true},
                    {value: 'user_name', text: 'Username', visible: true},
                    {value: 'edit_user', text: 'Edit customer', visible: true, not_sortable: true, no_export: true},
                    {value: 'order_link', text: 'TEXT_LIST_ORDER_DETAILS', visible: true, not_sortable: true}

                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {
                        value: 'local_date',
                        isDate: true,
                        text: 'Local date',
                        dateFormat: 'shortDate',
                        visible: true,
                        not_sortable: true
                    },
                    {value: 'local_time', text: 'Local time', visible: true, not_sortable: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'created', text: 'TEXT_LIST_CREATED_TIME', visible: true},
                    {value: 'delivered', text: 'TEXT_LIST_DELIVERED_TIME', visible: true},
                    {value: 'comment', text: 'TEXT_LIST_ORDER_COMMENT', visible: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'number', text: 'TEXT_LIST_ORDER_NUMBER', visible: true},
                    {value: 'status', text: 'TEXT_LIST_ORDER_STATUS', visible: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'payment_method', text: 'TEXT_LIST_PAYMENT_METHOD', visible: true},
                    {value: 'paid', text: 'TEXT_LIST_PAID_STATUS', visible: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'amount', text: 'Amount', visible: true},
                    {value: 'services_amount', text: 'Services amount', visible: true},
                    {value: 'shipping_amount', text: 'TEXT_LIST_DELIVERY_COST', visible: true},
                    {value: 'amount_to_pay', text: 'Payment amount', visible: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'discount_amount', text: 'Discount amount', visible: true},
                    {value: 'bonuses_redeemed_amount', text: 'Bonuses redeemed', visible: true},
                    {value: 'bonuses_added_amount', text: 'Bonuses earned', visible: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'comment', text: 'Corporate contact comment', visible: true},

                ]
            }

        ];
        // Добавляем возможность отобразить пустую колонку в экспортируемом документе
        $scope.data.table_cols_preset = CustomPreferencesService.addBlankColumns($scope.data.table_cols_preset);
        // Список форматов дат для настройки полей с датами
        $scope.dateFormats = CustomPreferencesService.dateFormats;

        var block_orders_list = blockUI.instances.get('orders_list');
        var filterTimeout;
        SettingsService.GetPlatformParams(function (success, response) {

            if (success) {
                $scope.isSupportUserExternalId = !!response.support_external_id_primary_identifier;

                if ($scope.isSupportUserExternalId) {
                    $scope.data.table_cols_preset[0].data.splice(($scope.data.table_cols_preset[0].data.length - 3), 0, {
                        value: 'user_external_id',
                        text: 'Customer external id',
                        visible: true,
                        not_sortable: true
                    });
                    // $scope.data.table_cols_preset[0].data.push({
                    //     value: 'user_external_id',
                    //     text: 'Customer external id',
                    //     visible: true,
                    //     not_sortable: true
                    // });
                }
            }
            initController();
        });


        function initOrdersFiters() {
            $scope.params.orders = angular.copy($scope.params.orders_preset);
        }

        function initTableColumns(isReset) {
            if (!isReset) {
                block_orders_list.start();
                CustomPreferencesService.initTableColumns(
                    customPreferencesKey,
                    $scope.data.table_cols_preset
                ).then(function (preferences) {
                    $scope.data.table_cols = preferences.tableColumns;
                    $timeout(function () {
                        block_orders_list.stop();
                    }, 1000);
                })
            } else {
                $scope.data.table_cols = angular.copy($scope.data.table_cols_preset);
            }

            if ($rootScope.ENV.business.status.show_sc_in_transations_list === 1)
                for (var i in $scope.data.table_cols)
                    $scope.data.table_cols[i].enabled = true;
        }

        function initController() {
            initOrdersFiters();
            getSpecialAccounts();

            initTableColumns();
        }

        function _doShow(reloadOrders) {
            if (reloadOrders === true) {
                getOrders();
            }

            function s() {
                if ($rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.export_transactions_list)
                        $rootScope.TARIFF_LIMITATION.export_transactions_list = false;
                    else
                        $rootScope.TARIFF_LIMITATION.export_transactions_list = true;
                } else {
                    $timeout(s, 250);
                }
            }

            s();
        }

        function getOrders() {
            block_orders_list.start();
            $scope.data.ordersList = null;
            $scope.data.summary = {};

            initTableColumns();

            var params = angular.copy($scope.params.orders);

            params.sort = '{0} {1}'.format(params.sort_field, params.sort_direction);
            delete params.sort_direction;
            delete params.sort_field;

            params.date_from = moment(params.date_from).set({
                hour: moment(params.time_from).get('hour'),
                minute: moment(params.time_from).get('minute'),
                second: moment(params.time_from).get('second')
            });
            delete params.time_from;

            params.date_to = moment(params.date_to).set({
                hour: moment(params.time_to).get('hour'),
                minute: moment(params.time_to).get('minute'),
                second: moment(params.time_to).get('second')
            });
            delete params.time_to;

            if ($scope.data.currentFilter && $scope.data.currentFilter.id !== '0') {
                var cf = $scope.data.currentFilter;
                switch (cf.filter_list_type) {
                    case 'loyalty':
                        params.loyalty = cf.id;
                        break;
                }
            }

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]', true);
            params = cleanRequestData(params);


            OrderService.All(params, function (success, response) {
                if (success) {
                    $scope.data.ordersList = response.data;
                    $scope.data.summary = response.summary;

                    updateOrdersSummary();

                    $rootScope.ENV.filters.orders_list.params = JSON.stringify($scope.params.orders);
                    $rootScope.storeENV();
                }
                $timeout(function () {
                    block_orders_list.stop();
                }, 1000);
            });
        }

        function updateOrdersSummary() {
            $scope.data.summary_cols = [];

            for (var i in $scope.data.table_cols) {
                if ($scope.data.table_cols[i].enabled)
                    if (i == 0)
                        $scope.data.summary_cols.push({
                            visible: $scope.data.table_cols[i].visible,
                            data: [$filter('translate')('Total values')]
                        });
                    else
                        $scope.data.summary_cols.push({visible: $scope.data.table_cols[i].visible, data: []});

                for (var k in $scope.data.table_cols[i].data) {
                    if ($scope.data.table_cols[i].data[k].visible) {
                        switch ($scope.data.table_cols[i].data[k].value) {
                            case 'amount':
                                $scope.data.summary_cols[i].data.push($scope.data.summary.total_amount);
                                break;
                            case 'shipping_amount':
                                $scope.data.summary_cols[i].data.push($scope.data.summary.total_shipping_amount);
                                break;
                            case 'bonuses_redeemed_amount':
                                $scope.data.summary_cols[i].data.push($scope.data.summary.total_bonuses_redeemed_amount);
                                break;
                            case 'discount_amount':
                                $scope.data.summary_cols[i].data.push($scope.data.summary.total_discount_amount);
                                break;
                            case 'amount_to_pay':
                                $scope.data.summary_cols[i].data.push($scope.data.summary.total_amount_to_pay);
                                break;
                        }
                    }
                }
            }
        }

        function getSpecialAccounts() {
            BusinessService.SpecialAccounts(function (success, response) {
            });
        }

        function popupOrderDetail(order) {
            $scope.operationResult = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/templates/modal.order.details.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {
                        order: order
                    };

                    popup.model.loyalty = {
                        id: order.loyalty_id,
                        title: order.loyalty_title
                    };

                    if (popup.model.order.loyalty_id) {
                        LoyaltyService.LoyaltyOnlineStore(popup.model.order.loyalty_id, function (success, response) {
                            if (success) {
                                popup.model.onlinestore = response;
                            }
                        });
                    }

                    if (popup.model.order.shipping) {
                        popup.model.order_shipping = {
                            delivery_title: null,
                            delivery_date: null,
                            delivery_time: null,
                            ship_to_address: null,
                            ship_to_phone: null,
                            ship_to_name: null
                        };

                        if (popup.model.order.shipping.delivery_date) {
                            popup.model.order_shipping.delivery_date = popup.model.order.shipping.delivery_date;
                        }
                        if (popup.model.order.shipping.delivery_time) {
                            popup.model.order_shipping.delivery_time = popup.model.order.shipping.delivery_time;
                        }

                        if (popup.model.order.shipping.delivery && popup.model.order.shipping.delivery.title) {
                            popup.model.order_shipping.delivery_title = popup.model.order.shipping.delivery.title;
                        }

                        if (popup.model.order.shipping.ship_to) {
                            if (popup.model.order.shipping.ship_to.address) {
                                popup.model.order_shipping.ship_to_address = popup.model.order.shipping.ship_to.address;
                            }
                            if (popup.model.order.shipping.ship_to.phone) {
                                popup.model.order_shipping.ship_to_phone = popup.model.order.shipping.ship_to.phone;
                            }
                            if (popup.model.order.shipping.ship_to.first_name) {
                                popup.model.order_shipping.ship_to_name = popup.model.order.shipping.ship_to.first_name;
                                if (popup.model.order.shipping.ship_to.last_name) {
                                    popup.model.order_shipping.ship_to_name += ' ';
                                    popup.model.order_shipping.ship_to_name += popup.model.order.shipping.ship_to.last_name;
                                }
                            }
                        }
                    }

                    popup.model.active_transaction = null;
                    if (popup.model.order.transaction && popup.model.order.transaction.length > 0) {
                        for (var i in popup.model.order.transaction) {
                            if (popup.model.order.transaction[i].canceled === false) {
                                popup.model.active_transaction = popup.model.order.transaction[i];
                                break;
                            }
                        }
                    }
                    if (popup.model.active_transaction) {
                        if (popup.model.active_transaction.payments) {
                            if (popup.model.active_transaction.payments) {
                                if (popup.model.active_transaction.payments.length == 1) {
                                    switch (popup.model.active_transaction.payments[0].type) {
                                        case 'cash':
                                            popup.model.payment = {
                                                payment_type: 'cash',
                                                paid_by_cash: popup.model.active_transaction.payments[0].amount,
                                                paid_time: popup.model.active_transaction.processed
                                            };
                                            break;
                                        case 'bank-card':
                                            popup.model.payment = {
                                                payment_type: 'card',
                                                paid_by_card: popup.model.active_transaction.payments[0].amount,
                                                paid_time: popup.model.active_transaction.processed
                                            };
                                            break;
                                        case 'mobile-app':
                                            popup.model.payment = {
                                                payment_type: 'mobile',
                                                paid_by_mobile: popup.model.active_transaction.payments[0].amount,
                                                paid_time: popup.model.active_transaction.processed
                                            };
                                            break;
                                    }
                                } else if (popup.model.active_transaction.payments.length == 2) {
                                    popup.model.payment = {
                                        payment_type: 'mixed',
                                        paid_time: popup.model.active_transaction.processed
                                    };
                                    for (var i in popup.model.active_transaction.payments) {
                                        if (popup.model.active_transaction.payments[i].type === 'cash') {
                                            popup.model.payment.paid_by_cash = popup.model.active_transaction.payments[i].amount;
                                        } else if (popup.model.active_transaction.payments[i].type === 'bank-card') {
                                            popup.model.payment.paid_by_card = popup.model.active_transaction.payments[i].amount;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (popup.model.order.user_id) {
                        CustomerService.BusinessCustomer(popup.model.order.user_id, popup.model.order.loyalty_id, function (success, response) {
                            if (success) {
                                popup.model.clientinfo = response;
                            }
                        });
                    }

                    popup.orderCurrency = '';

                    if (popup.model.order.check.payment_type === 'currency') {
                        popup.orderCurrency = popup.model.order.check.payment_id;
                    } else if (!!popup.model.order.check.special_account && popup.model.order.check.payment_type === 'special-account') {
                        popup.orderCurrency = popup.model.order.check.special_account.currency || '';
                    } else if (!!popup.model.order.transaction) {
                        var transactionFind = popup.model.order.transaction.find(function (transaction) {
                            return !!transaction.special_account_id && popup.model.order.check.payment_id === transaction.special_account_id;
                        });
                        if (transactionFind) {
                            popup.orderCurrency = transactionFind.currency;
                        }
                    }

                    popup.getAccountTitle = function (account_id) {
                        if ($rootScope.ACCOUNTS) {
                            return itemByIndex($rootScope.ACCOUNTS, account_id).public_title;
                        }
                    };

                    popup.onOrderPrint = function () {
                        var printContents = document.getElementById('printable-order').innerHTML;
                        var popupWin = window.open('', '_blank', 'screenX=1,screenY=1,left=1,top=1,' + 'width=' + screen.availWidth + ',height=' + screen.availHeight);
                        popupWin.document.open();
                        popupWin.document.write('<html><head><base href="/"><title></title><link href="assets/print/print.min.css" rel="stylesheet"/></head><body>' + printContents + '</body></html>');
                        popupWin.focus();
                        // setTimeout(function () {
                        //     popupWin.document.execCommand('print');
                        //     popupWin.print();
                        //     popupWin.document.close();
                        //     popupWin.close();
                        // }, 10);
                        var count = popupWin.document.querySelectorAll('img, link').length;

                        function printOnLoad() {
                            setTimeout(function () {
                                popupWin.focus();
                                popupWin.document.execCommand('print');
                                // popupWin.print();
                                popupWin.document.close();
                                popupWin.close();
                            }, 200);
                        }

                        if (count) {
                            popupWin.document.querySelectorAll('img, link').forEach(function (el) {
                                el.onload = function () {
                                    if (!--count) {
                                        printOnLoad()
                                    }
                                };
                            });
                        } else {
                            printOnLoad()
                        }
                    };

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            });
        }

        $scope.onGetOrder = function (order) {
            OrderService.GetOrderInfo(order.id, function (success, response) {
                if (success) {
                    popupOrderDetail(response, order);
                }
            });
        };

        function getOrderStatusDescription(order_status) {
            var res;
            switch (order_status) {
                case 'created':
                    res = 'TEXT_ORDER_STATUS_CREATED';
                    break;
                case 'inprocess':
                    res = 'TEXT_ORDER_STATUS_INPROCESS';
                    break;
                case 'delivered':
                    res = 'TEXT_ORDER_STATUS_DELIVERED';
                    break;
                case 'canceled':
                    res = 'TEXT_ORDER_STATUS_CANCELED';
                    break;
                default:
                    res = '';
            }
            return res;
        }

        function getOrderPaymentTypeDescription(payment_type) {
            var res;
            switch (payment_type) {
                case 'payment-at-checkout':
                    res = 'TEXT_PAYMENT_AT_CHECKOUT';
                    break;
                case 'payment-upon-receipt':
                    res = 'TEXT_PAYMENT_UPON_RECEIPT';
                    break;
                default:
                    res = '';
            }
            return res;
        }

        function getOrderPaidDescription(paid) {
            var res = 'No';

            if (paid && paid > 0) {
                res = 'TEXT_PAID';
            }
            return res;
        }

        $scope.onOrdersExport = function (format) {
            var isExportStopped = false;

            $scope.modalExport = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.export.html',
                controllerAs: 'exportModal',
                controller: function ($uibModalInstance) {
                    $scope.exportModal = this;

                    // Прогресс загрузки в процентах
                    $scope.exportModal.exportProgress = 0.1;

                    // Количество загруженных записей
                    $scope.exportModal.downloadedDataCount = 0;

                    // Все количество загружаемых записей
                    $scope.exportModal.allDataCount = 0;

                    // Признак - находится ли экспорт на паузе
                    $scope.exportModal.isExportPaused = false;

                    $scope.exportModal.onTogglePause = function () {
                        $scope.exportModal.isExportPaused = !$scope.exportModal.isExportPaused;
                        if (!$scope.exportModal.isExportPaused) {
                            exportRequest();
                        }
                    };

                    $scope.exportModal.onStop = function () {
                        isExportStopped = true;
                        $scope.modalExport.close();
                        if ($scope.exportModal.isExportPaused) {
                            handleExportResults();
                        }
                    }

                    $scope.exportModal.onExit = function () {
                        $scope.exportModal.isExportPaused = true;
                        $scope.data.isFilePreparing = false;
                        $uibModalInstance.close();
                    };
                }
            });

            $scope.data.isFilePreparing = true;

            var params = angular.copy($scope.params.orders);

            params.sort = '{0} {1}'.format(params.sort_field, params.sort_direction);
            delete params.sort_direction;
            delete params.sort_field;

            if ($scope.model.by_stock)
                params.by_stock = true;

            params.date_from = moment(params.date_from).set({
                hour: moment(params.time_from).get('hour'),
                minute: moment(params.time_from).get('minute'),
                second: moment(params.time_frome).get('second')
            });
            delete params.time_from;

            params.date_to = moment(params.date_to).set({
                hour: moment(params.time_to).get('hour'),
                minute: moment(params.time_to).get('minute'),
                second: moment(params.time_to).get('second')
            });
            delete params.time_to;

            if ($scope.data.currentFilter && $scope.data.currentFilter.id !== '0') {
                var cf = $scope.data.currentFilter;
                switch (cf.filter_list_type) {
                    case 'loyalty':
                        params.loyalty = cf.id;
                        break;
                }
            }

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]', true);
            params = cleanRequestData(params);

            var tl = [];

            function generateFile() {
                var file_name = $rootScope.ENV.business.code + '_orders_' + moment($scope.params.orders.date_from).format('YYYY-MM-DD_HH:mm:ss') + '_' + moment($scope.params.orders.date_to).format('YYYY-MM-DD_HH:mm:ss');

                var export_struct = ExportService.getTableForExcel(format, angular.copy($scope.data.table_cols));

                if ($scope.model.by_stock) {
                    export_struct = export_struct.concat(by_stock_fields);
                }

                var export_data = [];
                for (var i in tl) {
                    var el = {};
                    for (var k in export_struct) {
                        var a, b;
                        a = export_struct[k].text;

                        switch (export_struct[k].value) {
                            case 'status':
                                b = $filter('translate')($scope.getOrderStatusDescription(tl[i][export_struct[k].value]));
                                break;
                            case 'payment_method':
                                b = $filter('translate')($scope.getOrderPaymentTypeDescription(tl[i][export_struct[k].value]));
                                break;
                            case 'local_date' :
                                b = $filter('date')(tl[i]['created_local'], export_struct[k].dateFormat, '+0');
                                break;
                            case 'local_time' :
                                b = $filter('date')(tl[i]['created_local'], 'mediumTime', '+0');
                                break;
                            case 'amount':
                            case 'shipping_amount':
                            case 'summary_amount':
                            case 'amount_to_pay':
                            case 'services_amount':
                            case 'discount_amount':
                                b = $filter('currencyFormat')(tl[i][export_struct[k].value] || 0, tl[i].currency, tl[i]['amount_decimal_digits'] || 2);
                                break;
                            case 'bonuses_added_amount':
                            case 'bonuses_redeemed_amount':
                            case 'bonuses_on_account':
                                b = $filter('currencyFormat')(tl[i][export_struct[k].value] || 0, tl[i].currency, tl[i]['bonuses_decimal_digits'] || 2);
                                break;
                            default:
                                b = (tl[i][export_struct[k].value] === null) ? '' : tl[i][export_struct[k].value];
                        }
                        el[a] = b || '';
                    }
                    export_data.push(el);
                }

                $scope.$evalAsync(function ($scope) {
                    $scope.data.isFilePreparing = false;
                });

                switch (format) {
                    case 'XLSX':
                        alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'XLS':
                        alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'CSV':
                        alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [export_data]);
                        break;
                }
            }

            // Номер текущей страницы с записями для загрузки
            var currentPage = 0;

            // Загруженные значения для экспорта
            var exportValues = [];

            // Количество записей загружаемых за один запрос к серверу
            var partCount = 200;

            // Массив параметров для запросов к серверу
            var exportParams = ExportService.generateExportParams(params, $scope.data.summary.total_rows_count, partCount);

            // Получение следующего массива записей
            function downloadNextPage(exportParams, currentPage) {
                return new Promise(function (resolve) {
                    getOrders(exportParams[currentPage]).then(function (resp) {
                        exportValues = [...exportValues, resp]
                        currentPage++;
                        ExportService.calculateExportValuesCount($scope, exportValues, $scope.data.summary.total_rows_count);
                        if (!isExportStopped
                            && !$scope.exportModal.isExportPaused
                            && exportParams[currentPage]) {
                            downloadNextPage(exportParams, currentPage).then(function (response) {
                                resolve(response);
                            })
                        } else {
                            resolve({currentPage: currentPage});
                        }
                    });
                })
            }

            function exportRequest() {
                downloadNextPage(exportParams, currentPage).then(function (response) {
                    currentPage = response.currentPage;
                    if (isExportStopped || !exportParams[currentPage]) {
                        $scope.modalExport.close();
                        handleExportResults();
                    }
                })
            }

            function handleExportResults() {
                var result = {};
                result.data = [];
                result.summary = {};
                exportValues.forEach(function (value) {
                    result.data = result.data.concat(value.data);
                    result.summary = value.summary;
                });
                tl = result.data;

                generateFile();
            }


            function getOrders(params) {
                return new Promise(function (resolve) {
                    OrderService.All(params, function (success, response) {
                        resolve(response);
                    });
                })
            }

            exportRequest();
        };

        $scope.getTableHeaderClass = function (row) {
            return {
                'sorting_asc': $scope.params.orders.sort_field == row.value && $scope.params.orders.sort_direction == 'ASC',
                'sorting_desc': $scope.params.orders.sort_field == row.value && $scope.params.orders.sort_direction == 'DESC',
                'sorting': !row.not_sortable
            }
        };

        $scope.onSortOrderChange = function (row) {
            if (!!row.not_sortable) {
                return;
            }
            var field = row.value;
            if ($scope.params.orders.sort_field === field)
                $scope.params.orders.sort_direction = $scope.params.orders.sort_direction == "ASC" ? "DESC" : "ASC";

            $scope.params.orders.sort_field = field;

            getOrders();
        };

        $scope.pageChange = function () {
            getOrders();
        };

        $scope.onCountChange = function (count) {
            $scope.params.orders.page = 1;
            $scope.params.orders.count = count;
            getOrders();
        };

        $scope.onDisplaySettingsClick = function () {
            if ($scope.data.showTableDisplaySettings) {
                updateOrdersSummary();

                CustomPreferencesService.saveCustomPreference(
                    customPreferencesKey,
                    {tableColumns: $scope.data.table_cols}
                ).then(function () {
                    block_orders_list.stop();
                }, function () {
                    block_orders_list.stop();
                })
            }

            $scope.data.showTableDisplaySettings = !$scope.data.showTableDisplaySettings;
        };

        $scope.onDisplaySettingsSave = function () {
            $scope.onDisplaySettingsClick();
        };

        $scope.onColumnDisplayChange = function (index) {
            for (var i in $scope.data.table_cols[index].data)
                $scope.data.table_cols[index].data[i].visible = $scope.data.table_cols[index].visible;
        };

        $scope.onColumnDataDisplayChange = function (index) {
            $scope.data.table_cols.forEach(function (column) {
                column.visible = column.data.some(function (data) {
                    return data.visible;
                });
            })
        }

        $scope.onColumnAdd = function (first) {
            if (first)
                $scope.data.table_cols.unshift({visible: true, data: []});
            else
                $scope.data.table_cols.push({visible: true, data: []});
        };

        $scope.onColumnsReset = function () {
            initTableColumns(true);
        };

        $scope.onColumnRemove = function (index) {
            $scope.data.table_cols.splice(index, 1);
        };

        $scope.onOrderCancel = function (id) {
            var post_data = {
                status: 'canceled'
            };

            OrderService.SetOrderStatus(id, post_data, function (success, response) {
                if (success)
                    itemByIndex($scope.data.ordersList, id).status = 'canceled';
            });
        };

        $scope.onOrderInprocess = function (id) {
            var post_data = {
                status: 'inprocess'
            };

            OrderService.SetOrderStatus(id, post_data, function (success, response) {
                if (success)
                    itemByIndex($scope.data.ordersList, id).status = 'inprocess';
            });
        };

        $scope.onOrderDelivered = function (id) {
            var post_data = {
                status: 'delivered'
            };

            OrderService.SetOrderStatus(id, post_data, function (success, response) {
                if (success)
                    itemByIndex($scope.data.ordersList, id).status = 'delivered';
            });
        };

        $rootScope.$watch('L_LIST', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.filtersList = angular.copy($rootScope.L_LIST);
                $scope.data.filtersList.unshift({title: $filter('translate')('All loyalties'), id: '0', active: 1});

                if ($rootScope.ENV.filters.orders_list) {
                    try {
                        $scope.params.orders = JSON.parse($rootScope.ENV.filters.orders_list.params);
                        $scope.params.orders.date_from = moment().subtract(1, 'month').utc().toDate();
                        $scope.params.orders.date_to = moment().endOf('day').utc().toDate();
                        $scope.params.orders.time_from = moment().startOf('day').utc().toDate();
                        $scope.params.orders.time_to = moment().endOf('day').utc().toDate();
                        // $scope.params.orders.status       = 'all';
                        // $scope.params.orders.paid         = 'all';

                        $scope.params.orders.page = 1;
                    } catch (e) {
                        $scope.params.orders = angular.copy($scope.params.orders_preset);
                    }
                }

                if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
                    $scope.data.currentFilter = $scope.data.filtersList.find(function (filterItem) {
                        if (filterItem.filter_list_type === 'loyalty') {
                            if (filterItem.id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                return true;
                            }
                        } else if (filterItem.filter_list_type === 'pos' || filterItem.filter_list_type === 'register') {
                            if (filterItem.loyalty_id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                return true;
                            }
                        }
                    });
                } else {
                    for (var i in $scope.data.filtersList)
                        if ($scope.data.filtersList[i].id === '0')
                            $scope.data.currentFilter = $scope.data.filtersList[i];
                }
            }
        });


        $scope.$watch('data.currentFilter', function (newValue, oldValue) {
            if (newValue) {
                _doShow(false);

                var l = $rootScope.ENV.filters.orders_list;
                if (l)
                    l.filter = newValue
                else
                    l = {filter: newValue}

                $rootScope.ENV.filters.orders_list = l;

                if (l.filter.filter_list_type === 'loyalty') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: l.filter.id}
                } else if (l.filter.filter_list_type === 'pos' || l.filter.filter_list_type === 'register') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: l.filter.loyalty_id}
                } else if (l.filter.id === '0') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: '0'}
                }

                $rootScope.storeENV();
            }
        }, true);

        $scope.$watchCollection('[params.orders.user_phone, params.orders.user_external_id, params.orders.comment, params.orders.user_number, params.orders.status, params.orders.paid]', function (newCollection, oldCollection) {
            if (newCollection && newCollection !== oldCollection) {
                // if (filterTimeout)
                //     $timeout.cancel(filterTimeout);
                //
                // filterTimeout = $timeout(function() {
                //     $scope.params.orders.page = 1;
                //
                //     getOrders();
                // }, 1000);
            }
        });

        var dateDiff = appConfig.dateDifferences && appConfig.dateDifferences.orders ? appConfig.dateDifferences.orders : 1;

        $scope.$watch('params.orders.date_to', function (newValue, oldValue) {
            if (!!newValue && (moment(newValue).diff($scope.params.orders.date_from, 'months', true)) > dateDiff)
                $scope.params.orders.date_from = moment($scope.params.orders.date_to).subtract(dateDiff, 'month').utc().toDate();
        });

        $scope.$watch('params.orders.date_from', function (newValue, oldValue) {
            if (!!newValue && (moment($scope.params.orders.date_to).diff(newValue, 'months', true)) > dateDiff)
                $scope.params.orders.date_to = moment($scope.params.orders.date_from).add(dateDiff, 'month').utc().toDate();
        });
    }
})();
